import React, { Component } from 'react';
import { FiPlus } from 'react-icons/fi';
import '../../App.css';

import { LoadingSpinner } from '../common/loading-spinner/LoadingSpinner';
import BoardTile from './BoardTile/BoardTile';

import { loadBoards } from '../../services/api/api';

import '../../style/Common.css';
import './Overview.css';

export default class OwnBoards extends Component {
  constructor() {
    super();
    this.state = {
      boards: [],
      loading: true
    };
  }

  async componentDidMount() {
    const boards = await loadBoards();
    const ownedBoards = boards.filter(board => board.role === 'owner');

    this.setState({ boards: ownedBoards, loading: false });
  }

  renderBoards = boardCount => {
    return (
      <div className="text-center">
        {boardCount === 0 ? (
          <div>
            <div className="m-b-1">You do not have any Circly board yet. </div>
            <div className="m-b-3">Create your first board now! </div>
            <button className="btn btn-primary btn-icon m-auto" onClick={this.openCreateModal}>
              <span className="m-r-1">
                <FiPlus size={'1.5rem'} />
              </span>
              Create new
            </button>
          </div>
        ) : (
          <div className="">
            <ul className="project-list d-flex flex-wrap">
              {this.state.boards.map(board => (
                <BoardTile
                  board={board}
                  key={`board-${board.id}`}
                  reloadBoards={this.reloadBoards}
                />
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  render() {
    const boardCount = this.state.boards.length;

    return (
      <div>
        <div className="projects-header d-flex">
          <h2>My own Circly boards</h2>
          {boardCount > 0 && (
            <button className="btn btn-primary btn-icon" onClick={this.props.openCreateModal}>
              <span className="m-r-1">
                <FiPlus size={'1.5rem'} />
              </span>
              Create new
            </button>
          )}
        </div>
        <div className="pt-2">
          {this.state.loading ? <LoadingSpinner /> : this.renderBoards(boardCount)}
        </div>
      </div>
    );
  }
}
